import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ConfirmModal from "../../ConfirmModal";
import "./style.scss";

interface Props {
  display: boolean;
  isGuest: boolean | undefined;
  onClose: () => void;
  onConfirm: () => void;
  onDismiss: () => void;
}

const QuitCustomizationModal: FunctionComponent<Props> = ({
  display,
  isGuest,
  onClose,
  onConfirm,
  onDismiss,
}) => {
  const intl = useIntl();
  const userType = isGuest === false ? "logged" : "guest";

  return (
    <ConfirmModal
      display={display}
      onClose={onClose}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
      dismissLabel={intl.formatMessage({
        id: "kustom_QuitCustomizationModal_quitWithoutSave",
      })}
      confirmLabel={intl.formatMessage({
        id: `kustom_QuitCustomizationModal_saveAndQuit__${userType}`,
      })}
    >
      <div className="QuitCustomizationModal">
        <h2 className="QuitCustomizationModal-title">
          {intl.formatMessage({
            id: `kustom_QuitCustomizationModal_title__${userType}`,
          })}
        </h2>
        <div className="QuitCustomizationModal-content">
          <p>
            {intl.formatMessage({
              id: `kustom_QuitCustomizationModal_content__${userType}`,
            })}
          </p>
        </div>
      </div>
    </ConfirmModal>
  );
};

export default QuitCustomizationModal;
